module.exports = __webpack_public_path__ + "img/xxjyzt.00017fc3.png";